import Vue from "vue";
import axios from "axios";
import Vuex from "vuex";
import VueLodash from "vue-lodash";
import { createStore } from 'vuex'
import { cookieService } from "../../../services/cookieService";
import areas from "./modules/areas";
import locations from "./modules/locations";
import types from "./modules/types";
import specialNeeds from "./modules/specialNeeds";
import filters from "./modules/filters";

Vue.use(VueLodash);
Vue.use(Vuex);

const AttractionsStore = createStore({
    modules: {
        areas,
        locations,
        types,
        specialNeeds,
        filters
    },
    state: {
        results: [],
        attractions: [],

        pageId: null,
        culture: "",
        noResultsText: ""
    },
    mutations: {
        setData(state, status) {
            state.attractions = status;
            
            state.pageId = state.attractions.find(attraction => {
                return Number.isInteger(attraction);
            });

            state.culture = state.attractions.find(attraction => {
                return typeof attraction === "string";
            });
        },
        SET_ATTRACTION_RESULTS(state, status) {
            state.results = [];
            state.results = status;
        },
        SET_NO_RESULTS_TEXT(state, status) {
            state.noResultsText = status;
        }
    },
    actions: {
        fetchData({ commit, dispatch, rootState }) {
            commit("setData", window.attractions);
            commit("areas/setAreaData", rootState);
            commit("locations/setLocationData", rootState);
            commit("types/setTypesData", rootState);
            commit("specialNeeds/setSpecialNeedsData", rootState);
            commit("filters/setFiltersData", rootState);

            if (cookieService.getCookie('attractions')) {
                let parsedCookies = JSON.parse(cookieService.getCookie('attractions'));

                dispatch('setValuesFromCookie', parsedCookies);
            }

            let getBody = this.getters.getBody;

            return axios({
                method: "post",
                url: `${window.merlinConfig.urlPrefix}/umbraco/api/FilteredParkItems/get`,
                data: getBody
            })
                .then(({ data }) => {
                    commit("SET_ATTRACTION_RESULTS", data.results);
                    commit("areas/updateAreas", rootState);
                })
                .catch(error => { });
        },
        filterAttractions({ commit, rootState }) {
            let getBody = {
                filters: filters.state.activeFilters,
                locations: locations.state.locationsEnabled ? locations.state.activeLocations.map(location => location) : null,
                areas: areas.state.areaEnabled ? areas.state.areaIds.map(area => area) : null,
                types: types.state.typesEnabled ? types.state.typeIds.map(type => type) : null,
                specialNeeds: specialNeeds.state.specialNeedsEnabled ? specialNeeds.state.specialNeedsIds.map(need => need) : null,
                height: filters.state.sliderFilterEnabled ? filters.state.height : null,
                pageId: this.state.pageId,
                culture: this.state.culture
            }

            cookieService.setCookie("attractions", JSON.stringify(getBody));

            return axios({
                method: "post",
                url: `${window.merlinConfig.urlPrefix}/umbraco/api/FilteredParkItems/get`,
                data: getBody
            }).then(({ data }) => {
                if (!data.results.length) {
                    commit("SET_NO_RESULTS_TEXT", data.NoResultsText);
                }
                commit("SET_ATTRACTION_RESULTS", data.results);
                commit("areas/updateAreas", rootState);
            });
        },
        setValuesFromCookie({ commit, state }, payload) {
            if (payload.height) {
                state.height = payload.height;
            }

            commit("types/setTypeValuesFromCookie", payload);
            commit("areas/setAreaValuesFromCookie", payload);
            commit("locations/setLocationValuesFromCookie", payload);
            commit("filters/setFilterValuesFromCookie", payload);
            commit("specialNeeds/setSpecialNeedsValuesFromCookie", payload);
        }
    },
    getters: {
        getResults: state => {
            return state.results;
        },
        getActiveAreas: (state) => {
            if (state.locations.activeLocations.length === 0) {
                return state.areas.areas.map(area => {
                    let obj = {};
                    obj.Key = area.KeyValuePair.Key;
                    obj.Value = area.KeyValuePair.Value;
                    obj.checked = false;
                    return obj;
                });
            } else {
                return state.areas.activeAreas;
            }
        },
        getBody: state => {
            return {
                filters: filters.state.activeFilters,
                locations: locations.state.locationsEnabled ? locations.state.activeLocations.map(location => location) : null,
                areas: areas.state.areaEnabled ? areas.state.areaIds.map(area => area) : null,
                types: types.state.typesEnabled ? types.state.typeIds.map(type => type) : null,
                specialNeeds: specialNeeds.state.specialNeedsEnabled ? specialNeeds.state.specialNeedsIds.map(need => need) : null,
                height: filters.state.sliderFilterEnabled ? filters.state.height : null,
                pageId: state.pageId,
                culture: state.culture
            };
        },
        getCulture: state => {
            return state.culture;
        },
        getPageId: state => {
            return state.pageId;
        }

    }
});

export { AttractionsStore };
